import { useTheme } from '@mui/material';

const ThemeSvg = (props) => {
  const theme = useTheme();
  return props.render(theme.palette.text.primary);
};

export default ThemeSvg;
